import { create } from 'zustand';

import { VOTING_PAGE_SIZE, type VotingOrderKey, type VotingStatus } from './voting';

interface VotingQueryState {
  search: string;
  status: 'all' | VotingStatus;
  order: VotingOrderKey;
  page: number;
  pageSize: number;
  setSearch: (search: string) => void;
  setStatus: (status: 'all' | VotingStatus) => void;
  setOrder: (order: VotingOrderKey) => void;
  setPage: (page: number) => void;
  setPageSize: (pageSize: number) => void;
  reset: () => void;
}

const defaults: Pick<VotingQueryState, 'search' | 'status' | 'order' | 'page' | 'pageSize'> = {
  search: '',
  status: 'all',
  order: 'newest',
  page: 1,
  pageSize: VOTING_PAGE_SIZE,
};

export const useVotingStore = create<VotingQueryState>((set) => ({
  ...defaults,

  setSearch: (search) => set({ search, page: 1 }),
  setStatus: (status) => set({ status, page: 1 }),
  setOrder: (order) => set({ order, page: 1 }),
  setPage: (page) => set({ page }),
  setPageSize: (pageSize) => set({ pageSize, page: 1 }),

  reset: () => set(defaults),
}));
